(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
        function moveCollectionDescription() {
              const description = document.querySelector('.collection__description');
                  const products = document.querySelector('.product-list--collection');
                      if (description && products) products.insertAdjacentElement('afterend', description);
                        }

                          moveCollectionDescription();
                            document.addEventListener('shopify:section:load', moveCollectionDescription);
                            
  } catch(e) { console.error(e); }
})();
})();
